import { render, staticRenderFns } from "./UidAuth.vue?vue&type=template&id=0f513f66&scoped=true&"
import script from "./UidAuth.vue?vue&type=script&lang=js&"
export * from "./UidAuth.vue?vue&type=script&lang=js&"
import style0 from "./UidAuth.vue?vue&type=style&index=0&id=0f513f66&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f513f66",
  null
  
)

export default component.exports